export default __webpack_public_path__ + "static/media/Profile Image.50490d35.png";